// List of different sources of events within trailmixes functionality

export const SOURCE_ASSESSMENT_ATTEMPTED = 'Assessment';
export const SOURCE_BUTTON_FOLLOW = 'Organic_Follow';
export const SOURCE_BUTTON_UNFOLLOW = 'Organic_Unfollow';
export const SOURCE_CUSTOM_STEP = 'Custom_Step';
export const SOURCE_QUIZ_ATTEMPTED = 'Quiz';
export const SOURCE_SUPERBADGE_ATTEMPTED = 'Superbadge';
